import { PUBLIC_ID, FIRST_NAME, BIRTH } from 'store/patients';
import { SORT_BY, SORT_DIR, ASC, DELETE_REASON } from 'store/planning';
import { DELETE_REASONS } from '../utils';

export const DEFAULT_SORT = { [SORT_BY]: PUBLIC_ID, [SORT_DIR]: ASC };

export const TABLE_HEAD = [
  { id: PUBLIC_ID, content: 'ID', width: '8%', withoutSort: true },
  { id: FIRST_NAME, content: 'Name', width: '47%', withoutSort: true },
  { id: BIRTH, content: 'Geburtstag', width: '28%', withoutSort: true },
  { id: DELETE_REASON, content: 'Grund', width: '17%', withoutSort: true },
];

export const DELETE_REASONS_OBJECT = DELETE_REASONS.reduce((acc, { id, label }) => ({ ...acc, [id]: label }), {});
